import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import './YearPickerComponent.scss'; 

export type YearPickerProps = {
  labelName?: string;
  className?: string;
  isError?: boolean;
  isWarning?: boolean;
  isRequired?: boolean;
  name?: string;
  isCorrect?: boolean;
  inLine?: boolean;
  labelSize?: string;
  minYear?: Date;
  maxYear?: Date;
  selected?: Date | null; // Add selected prop here
  onChange: (date: Date | null) => void; // onChange handler to accept Date | null
};

const YearPickerComponent = React.forwardRef<DatePicker, YearPickerProps>((props, ref) => {
  const {
    labelName,
    className,
    isError,
    isWarning,
    isRequired,
    name,
    isCorrect,
    inLine,
    labelSize,
    minYear,
    maxYear,
    selected, // Ensure selected is here
    onChange, // Proper onChange handler
    ...rest
  } = props;
  
  return (
    <Col>
      <Form.Group>
        {labelName ? (
          <Form.Label>
            {labelName} {isRequired && <span>*</span>}
          </Form.Label>
        ) : null}
          <DatePicker
            {...rest}
            ref={ref} // Properly forward ref to DatePicker
            selected={selected} // Use selected prop for the date value
            onChange={onChange} // Trigger onChange for year selection
            showYearPicker // Enables year selection
            dateFormat="yyyy" // Format to display only the year
            className={`${className || ""} ${
              isError ? "border-danger" : ""
            } ${isWarning ? "border-warning" : ""} p-2`}
            name={name}
            placeholderText="Select Year"
            minDate={minYear} // Minimum year allowed
            maxDate={maxYear} // Maximum year allowed
            customInput={
                <input
                  style={{
                    width: '100%',
                    height: 'calc(1.5em + 0.75rem + 2px)',
                    padding: '0.375rem 0.75rem',
                    fontSize: '1rem',
                    boxSizing: 'border-box'
                  }}
                />
              }
          />
          {isCorrect && (
            <div className="isCorrect isCorrect-input">
              <RiCheckboxCircleFill />
            </div>
          )}
      </Form.Group>
    </Col>
  );
});

export default YearPickerComponent;
